<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        Danh sách thông báo
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <div class="text-left">
          <b-collapse
            v-bind:visible="mData.tableRules.showFormSearch"
            id="myFormSearch"
          >
            <b-card>
              <el-form
                ref="myForm"
                label-position="top"
                @submit.native.prevent
                :model="mData.tableRules.dataSearch.value"
                :rules="mData.validForm"
              >
                <b-row>
                  <b-col md="4" v-if="!showInputSearchTypeConfirm">
                    <el-form-item label="Tiêu đề">
                      <el-input
                        v-model="mData.tableRules.dataSearch.value.title"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </b-col>
                  <!-- <b-col md="3" v-if="showInputSearchTypeConfirm">
                    <el-form-item :label="mData.tableRules.dataSearch.value.type == 'ConfirmTourMessage' ? "Khách du lịch" : "Hướng dẫn viên"">
                      <el-select
                        v-model="mData.tableRules.dataSearch.value.from"
                        :placeholder="aLang.c_typeKeyToSearch"
                        clearable
                        filterable
                      >
                        <el-option
                          v-for="item in mData.dataDefault.listNameSearch"
                          :key="item.id"
                          :label="item.ho_ten && item.ho_ten.ho_ten ? item.ho_ten.ho_ten : 'Chưa có thông tin'"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col> -->

                  <b-col md="4" v-if="showInputSearchTypeConfirm">
                    <el-form-item
                      :label="
                        mData.tableRules.dataSearch.value.type ==
                        'ConfirmTourMessage'
                          ? "Khách du lịch"
                          : "Hướng dẫn viên"
                      "
                    >
                      <el-autocomplete
                        :disabled="mData.viewMode == 'detail'"
                        class="inline-input"
                        v-model="hoTen"
                        :fetch-suggestions="querySearchHoTen"
                        placeholder="Nhập từ khóa để tìm kiếm"
                        :trigger-on-focus="false"
                        @select="handleSelectHoTen"
                        @change="handleSelectHoTen"
                      >
                        <template slot-scope="{ item }">
                          <span class="link">{{ item.ho_ten.ho_ten }}</span>
                        </template>
                      </el-autocomplete>
                    </el-form-item>
                  </b-col>
                  <b-col md="4" v-if="showInputSearchTypeConfirm">
                    <el-form-item
                      :label="
                        mData.tableRules.dataSearch.value.type ==
                        'ConfirmTourMessage'
                          ? "Tên tour"
                          : "Phiếu điều tour"
                      "
                    >
                      <el-autocomplete
                        :disabled="mData.viewMode == 'detail'"
                        class="inline-input"
                        v-model="tenTour"
                        :fetch-suggestions="querySearchTour"
                        placeholder="Nhập từ khóa để tìm kiếm"
                        :trigger-on-focus="false"
                        @select="handleSelectTour"
                        @change="handleSelectTour"
                      >
                        <template slot-scope="{ item }">
                          <span class="link">
                            {{ item.ten_tour }} ({{
                              item.thoi_gian_bat_dau | dateFormat
                            }}
                            - {{ item.thoi_gian_ket_thuc | dateFormat }})
                          </span>
                        </template>
                      </el-autocomplete>
                    </el-form-item>
                  </b-col>
                  <!-- <b-col md="3" v-if="showInputSearchTypeConfirm">
                    <el-form-item :label=""Tên tour"">
                      <el-select
                        v-model="mData.tableRules.dataSearch.value['target.targetId']"
                        :placeholder="aLang.c_typeKeyToSearch"
                        clearable
                        filterable
                      >
                        <el-option
                          v-for="item in mData.dataDefault.listTourSearchs"
                          :key="item.id"
                          :label="item.ten_tour"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col> -->
                  <b-col md="4">
                    <el-form-item
                      label="Thời điểm tạo"
                      prop="createdTime"
                    >
                      <el-date-picker
                        type="date"
                        :format="aElement.datepicker.formatDate"
                        :valueFormat="aElement.datepicker.valueFormat"
                        v-model="mData.tableRules.dataSearch.value.createdTime"
                        :placeholder="aElement.datepicker.placeholderDate"
                        clearable
                      ></el-date-picker>
                    </el-form-item>
                  </b-col>
                  <b-col md="4" v-if="!showInputSearchTypeConfirm">
                    <el-form-item
                      label="Thời điểm hết hạn"
                      prop="expiredTime"
                    >
                      <el-date-picker
                        type="daterange"
                        :format="aElement.datepicker.formatDate"
                        :valueFormat="aElement.datepicker.valueFormat"
                        v-model="mData.expiredTime"
                        :placeholder="aElement.datepicker.placeholderDate"
                        range-separator="-"
                        start-placeholder="Từ ngày"
                        end-placeholder="Đến ngày"
                        clearable
                      ></el-date-picker>
                    </el-form-item>
                  </b-col>
                </b-row>
                <el-form-item class="text-center mb-0">
                  <el-button
                    type="info"
                    native-type="submit"
                    v-ladda
                    plain
                    @click="fn_tableSearch()"
                    >Tìm kiếm</el-button
                  >
                </el-form-item>
              </el-form>
            </b-card>
          </b-collapse>
        </div>
        <b-row>
          <b-col md="8">
            <div class="text-left mb-0">
              <b-row>
                <b-col md="4">
                  <el-select
                    v-model="mData.tableRules.dataSearch.value.type"
                    placeholder="Loại thông báo"
                    @change="
                      fn_changeTypeNoti(mData.tableRules.dataSearch.value.type)
                    "
                    filterable
                  >
                    <el-option
                      v-for="item in mData.dataDefault.typeNotifi"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code"
                    ></el-option>
                  </el-select>
                </b-col>
                <b-col md="4">
                  <el-select
                    v-model="mData.tableRules.dataSearch.value.language"
                    clearable
                    placeholder="Ngôn ngữ"
                    @change="fn_tableSearch()"
                    filterable
                  >
                    <el-option
                      v-for="item in mData.dataDefault.listNgonNgu"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </b-col>
              </b-row>
            </div>
          </b-col>
          <b-col md="4">
            <div class="text-right mb-2">
              <el-button @click="fn_tableShowFormSearch()" type="info" plain>{{
                "Ẩn/hiện tìm kiếm"
              }}</el-button>
              <el-button
                @click="fn_handle('create')"
                type="info"
                plain
                v-if="!showInputSearchTypeConfirm"
                >Thêm mới</el-button
              >
            </div>
          </b-col>
        </b-row>

        <el-table
          :data="mData.tableRules.data"
          border
          @selection-change="fn_tableSelectionChange"
          @sort-change="fn_tableSortChange"
          max-height="440"
          style="width: 100%"
          :default-sort="{
            prop: mData.tableRules.defaultSort[0],
            order: mData.tableRules.defaultSort[1],
          }"
        >
          <el-table-column
            type="selection"
            width="40"
            v-if="mData.tableRules.allowSelect"
          ></el-table-column>
          <el-table-column
            prop="intro"
            label="Loại thông báo"
            width="200"
            v-if="
              showCollumnTableContentTypeConfirmTourMessage ||
              showCollumnTableContentTypeConfirmPDTMessage
            "
          ></el-table-column>
          <el-table-column
            prop=""
            label="Nội dung"
            min-width="200"
            v-if="showCollumnTableContentTypeConfirmTourMessage"
          >
            <template slot-scope="scope">
              <p class="ws-normal">
                {{ scope.row.ten_from }}
                {{
                  scope.row.so_the_kdl &&
                  scope.row.so_the_kdl.substring(0, 2) == "84"
                    ? "(số điện thoại: " + scope.row.so_the_kdl + ")"
                    : "(số thẻ: " + scope.row.so_the_kdl + ")"
                }}
                đã
                {{
                  scope.row.intro == "Xác nhận tour"
                    ? "xác nhận tour"
                    : scope.row.intro == "Từ chối tour"
                    ? "từ chối tour"
                    : ""
                }}
                "{{ scope.row.ten_tour }}" vào lúc
                {{ scope.row.createdTime | dateTimeFormat }}
              </p>
            </template>
          </el-table-column>
          <el-table-column
            prop=""
            label="Nội dung"
            min-width="200"
            v-if="showCollumnTableContentTypeConfirmPDTMessage"
          >
            <template slot-scope="scope">
              <p class="ws-normal">
                {{ scope.row.ten_from_hdv }} (số thẻ:
                {{ scope.row.so_the_hdv }}) đã
                {{
                  scope.row.intro == "Từ chối phiếu điều tour"
                    ? "từ chối phiếu điều tour"
                    : scope.row.intro == "Xác nhận phiếu điều tour"
                    ? "xác nhận phiếu điều tour"
                    : ""
                }}
                "{{ scope.row.ten_tour }} ({{
                  scope.row.thoi_gian_bat_dau | dateFormat
                }}
                - {{ scope.row.thoi_gian_ket_thuc | dateFormat }})" vào lúc
                {{ scope.row.createdTime | dateTimeFormat }}
              </p>
            </template>
          </el-table-column>
          <el-table-column
            prop="type"
            :sortable="mData.tableRules.allowSorting"
            label="Loại thông báo"
            min-width="200"
            align
            :formatter="fn_formatterType"
            v-if="
              !showCollumnTableContentTypeConfirmTourMessage &&
              !showCollumnTableContentTypeConfirmPDTMessage
            "
          ></el-table-column>
          <el-table-column
            prop="title"
            label="Tiêu đề"
            min-width="150"
            v-if="
              !showCollumnTableContentTypeConfirmTourMessage &&
              !showCollumnTableContentTypeConfirmPDTMessage
            "
          ></el-table-column>
          <el-table-column
            prop="intro"
            label="Nội dung thông báo"
            width="350"
            v-if="
              !showCollumnTableContentTypeConfirmTourMessage &&
              !showCollumnTableContentTypeConfirmPDTMessage
            "
          ></el-table-column>
          <!-- <el-table-column
            prop="from"
            :sortable="mData.tableRules.allowSorting"
            label="Người gửi"
            width="150"
          ></el-table-column>-->
          <el-table-column
            prop="createdTime"
            :sortable="mData.tableRules.allowSorting"
            label="Thời điểm tạo"
            width="150"
            :formatter="fn_formatterDatetime"
            align="center"
            v-if="
              !showCollumnTableContentTypeConfirmTourMessage &&
              !showCollumnTableContentTypeConfirmPDTMessage
            "
          ></el-table-column>
          <el-table-column
            prop="expiredTime"
            :sortable="mData.tableRules.allowSorting"
            label="Thời điểm hết hạn"
            width="150"
            :formatter="fn_formatterDatetime"
            align="center"
            v-if="
              !showCollumnTableContentTypeConfirmTourMessage &&
              !showCollumnTableContentTypeConfirmPDTMessage
            "
          ></el-table-column>
          <!-- <el-table-column
              prop="isRead"
              :sortable="mData.tableRules.allowSorting"
              label="Đã đọc"
              width="100"
          ></el-table-column>-->

          <el-table-column
            label="Thao tác"
            align="center"
            width="150px"
            v-if="
              !showCollumnTableContentTypeConfirmTourMessage &&
              !showCollumnTableContentTypeConfirmPDTMessage
            "
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="fn_handle('detail', scope.$index, scope.row)"
                v-b-popover.hover.left="'Chi tiết'"
              >
                <i class="fa fa-eye"></i>
              </el-button>
              <!-- <el-button
                size="mini"
                @click="fn_handle('update',scope.$index, scope.row)"
                v-b-popover.hover.left="'Cập nhật'"
                v-if="aRole('Admin,Officer,TourAgent')"
              >
                <i class="icon-pencil icons"></i>
              </el-button>-->
              <el-button
                size="mini"
                @click="fn_handle('delete', scope.$index, scope.row)"
                v-b-popover.hover.left="'Xóa'"
                v-if="aRole('Admin,Officer,TourAgent')"
              >
                <i class="icon-trash icons"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
          <div class="col-md-4">
            <div v-if="mData.tableRules.allowSelect">
              Chọn: {{ mData.tableRules.recordSelected.length }}
            </div>
          </div>
          <div class="col-md-8 text-right">
            <el-pagination
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
              :page-sizes="mData.tableRules.lengthMenu"
              :page-size="mData.tableRules.limit"
              :current-page="mData.tableRules.page"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="mData.tableRules.total"
              :pager-count="5"
            ></el-pagination>
          </div>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
// import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import ExtensionService from "../../../service/ExtensionService";
import ThongBaoModel from "./ThongBaoModel";
import mushroomDulich from "../../../service/api/dulich-api";
import * as moment from "moment";

export default {
  filters: {
    dateTimeFormat: function (value) {
      let format = "HH:mm:ss DD/MM/yyyy";
      if (!value) return "";
      return moment(value).format(format);
    },
    dateFormat: function (value) {
      let format = "DD/MM/yyyy";
      if (!value) return "";
      return moment(value).format(format);
    },
  },
  data() {
    var validateTime = (rule, value, callback) => {
      let timeStart = this.mData.tableRules.dataSearch.value.createdTime;
      let timeEnd = this.mData.tableRules.dataSearch.value.expiredTime;

      if (timeStart && timeEnd) {
        let time1 = "";
        let time2 = "";

        if (typeof timeStart == "string") {
          time1 = new Date(timeStart);
        }
        if (typeof timeEnd == "string") {
          time2 = new Date(timeEnd);
        }

        if (time1.getTime() > time2.getTime()) {
          callback(new Error("Thời điểm tạo phải nhỏ hơn thời điểm hết hạn"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      hoTen: "",
      tenTour: "",
      loai_thong_bao: "",
      // aLang: LanguageService.lang,
      aRole: MethodService.checkRole,
      aElement: MethodService.element,
      currentUser: JSON.parse(localStorage.getItem("currentUser")),
      showTypeNotificationToAcceptOrRefuseTour: false,
      mData: {
        moduleName: "ThongBao", //requied
        urlImg: ExtensionService.urlImg,
        tableRules: MethodService.copyObject(ThongBaoModel.tableRules),
        expiredTime: null,
        validForm: {
          expiredTime: { validator: validateTime, trigger: "blur" },
        },
        dataDefault: {
          listKDL: [],
          listHDV: [],
          listTour: [],
          listPhieuDieuTour: [],
          listTourFromPhieuDieuTour: [],
          listKDLSearch: [],
          listHDVSearch: [],
          listTourSearch: [],
          listPhieuDieuTourSearch: [],
          listTourFromPhieuDieuTourSearch: [],
          listNameSearch: [],
          listTourSearchs: [],
          roles: DataService.roles,
          listNgonNgu: DataService.Languages,
          typeNotifi: [],
          typeNotificationTourAgent:
            ThongBaoModel.typeNotificationAcceptOrRefuseTour,
        },
      },
      showCollumnTableContentTypeConfirmTourMessage: false,
      showCollumnTableContentTypeConfirmPDTMessage: false,
      showInputSearchTypeConfirm: false,
    };
  },

  methods: {
    //get list table
    async fn_initTable() {
      if (this.mData.tableRules.dataSearch.value.type == "ConfirmTourMessage") {
        this.showCollumnTableContentTypeConfirmTourMessage = true;
        this.showCollumnTableContentTypeConfirmPDTMessage = false;
        this.showInputSearchTypeConfirm = true;
      } else if (
        this.mData.tableRules.dataSearch.value.type == "ConfirmPDTMessage"
      ) {
        this.showCollumnTableContentTypeConfirmTourMessage = false;
        this.showCollumnTableContentTypeConfirmPDTMessage = true;
        this.showInputSearchTypeConfirm = true;
      } else {
        this.showCollumnTableContentTypeConfirmTourMessage = false;
        this.showCollumnTableContentTypeConfirmPDTMessage = false;
        this.showInputSearchTypeConfirm = false;
      }
      let dataFilter = {
        filters: this.mData.tableRules.filters,
      };

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }

      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: "Admin-" + this.mData.moduleName + "-list",
            query: {
              limit: this.mData.tableRules.limit,
              page: this.mData.tableRules.page,
              sort: this.mData.tableRules.sort,
              filters: this.mData.tableRules.filters,
              showFormSearch: this.mData.tableRules.showFormSearch,
            },
          })
          .catch(() => {});
      }

      let res = await mushroomDulich.notification_log.listAsync(dataFilter);
      let resData = this.changeData(res.result);
      console.log("resData", resData);
      let fromIds = [];
      let targetArr = [];
      let tourtIds = [];
      fromIds = MethodService.findListItemDifferent(resData, "from");
      targetArr = MethodService.findListItemDifferent(resData, "target");
      tourtIds = MethodService.findListItemDifferent(targetArr, "targetId");
      const reqKhachDuLichApi = await mushroomDulich.khach_du_lich.listAsync({
        limit: fromIds.length,
        filters: "id:in:" + fromIds.join(","),
      });
      const reqHuongDanVienApi = await mushroomDulich.huong_dan_vien.listAsync({
        limit: fromIds.length,
        filters: "id:in:" + fromIds.join(","),
      });
      const reqTourApi = await mushroomDulich.tour.listAsync({
        limit: tourtIds.length,
        filters: "id:in:" + tourtIds.join(","),
      });
      const reqPhieuDieuTourApi = await mushroomDulich.phieu_dieu_tour.listAsync({
        limit: tourtIds.length,
        filters: "id:in:" + tourtIds.join(","),
      });
      let tourIdsFromPhieuDieuTour = MethodService.findListItemDifferent(
        reqPhieuDieuTourApi.result,
        "tour_id"
      );
      const reqTourFromPhieuDieuTour = await mushroomDulich.tour.listAsync({
        limit: tourIdsFromPhieuDieuTour.length,
        filters: "id:in:" + tourIdsFromPhieuDieuTour.join(","),
      });
      let resKhachDuLichApi = await reqKhachDuLichApi;
      let resHuongDanVienApi = await reqHuongDanVienApi;
      let resTourApi = await reqTourApi;
      let resPhieuDieuTourApi = await reqPhieuDieuTourApi;
      let resTourFromPhieuDieuTour = await reqTourFromPhieuDieuTour;

      this.mData.dataDefault.listKDL = resKhachDuLichApi.result;
      this.mData.dataDefault.listHDV = resHuongDanVienApi.result;
      this.mData.dataDefault.listTour = resTourApi.result;
      this.mData.dataDefault.listPhieuDieuTour = resPhieuDieuTourApi.result;
      this.mData.dataDefault.listTourFromPhieuDieuTour =
        resTourFromPhieuDieuTour.result;
      this.mData.dataDefault.listPhieuDieuTour.forEach((items) => {
        let tourFromPhieuDieuTour =
          this.mData.dataDefault.listTourFromPhieuDieuTour.find((element) => {
            return element.id == items.tour_id;
          });
        if (tourFromPhieuDieuTour) {
          items.ten_tour = tourFromPhieuDieuTour.ten_tour;
        }
      });

      resData.forEach(async (item) => {
        let fromKDL = this.mData.dataDefault.listKDL.find((element) => {
          return element.id == item.from;
        });
        if (fromKDL) {
          if (fromKDL.ho_ten.ho_ten) {
            item.ten_from = fromKDL.ho_ten.ho_ten;
          } else {
            item.ten_from = "Chưa có thông tin";
          }
          if (fromKDL.so_the) {
            item.so_the_kdl = fromKDL.so_the;
          } else {
            item.so_the_kdl = "";
          }
        }

        let fromHDV = this.mData.dataDefault.listHDV.find((element) => {
          return element.id == item.from;
        });
        if (fromHDV) {
          if (fromHDV.ho_ten.ho_ten) {
            item.ten_from_hdv = fromHDV.ho_ten.ho_ten;
          } else {
            item.ten_from_hdv = "Chưa có thông tin";
          }
          if (fromHDV.the_hdv.so_the) {
            item.so_the_hdv = fromHDV.the_hdv.so_the;
          } else {
            item.so_the_hdv = "Chưa có thông tin";
          }
        }

        let tour = this.mData.dataDefault.listTour.find((element) => {
          return element.id == item.target.targetId;
        });
        let phieuDieuTour = this.mData.dataDefault.listPhieuDieuTour.find(
          (element) => {
            return element.id == item.target.targetId;
          }
        );
        if (tour) {
          item.ten_tour = tour.ten_tour;
          item.thoi_gian_bat_dau = tour.thoi_gian_bat_dau;
          item.thoi_gian_ket_thuc = tour.thoi_gian_ket_thuc;
        } else if (phieuDieuTour) {
          item.ten_tour = phieuDieuTour.ten_tour;
          item.thoi_gian_bat_dau = phieuDieuTour.thoi_gian_bat_dau;
          item.thoi_gian_ket_thuc = phieuDieuTour.thoi_gian_ket_thuc;
        }
      });
      console.log("resData", resData);
      this.mData.tableRules.data = resData;
      this.mData.tableRules.total = res.meta.total;
      this.mData.tableRules.page = res.meta.offset / res.meta.limit + 1;
      if (
        this.mData.tableRules.offset == res.meta.total &&
        this.mData.tableRules.offset != 0
      ) {
        this.mData.tableRules.offset = 0;
        this.mData.tableRules.page = 1;
        this.fn_initTable();
      }
    },

    //xử lý dữ liệu đầu ra
    changeData(data) {
      data.forEach(async (items) => {
        if (items.intro == null) {
          items.intro = "Chưa có thông tin";
        }
      });
      return data;
    },

    //click button
    fn_handle(type, scope, row) {
      if (type == "create") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-create",
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: { id: row.id },
        });
      }
      if (type == "detail") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-detail",
          params: { id: row.id },
        });
      }
      if (type == "delete") {
        this.$confirm("Bạn có chắc chắn muốn xóa bản ghi này không?", {
          confirmButtonText: "Đồng ý",
          cancelButtonText: "Huỷ",
          type: "warning",
        })
          .then(() => {
            this.fn_delete(row.id);
          })
          .catch(() => {});
      }
      if (type == "disable") {
        this.$confirm("Bạn chắc chắn khóa người dùng này không?", {
          confirmButtonText: "Đồng ý",
          cancelButtonText: "Huỷ",
          type: "warning",
        })
          .then(() => {
            this.fn_disable(row.id, true);
          })
          .catch(() => {});
      }
      if (type == "openDisable") {
        this.$confirm("Bạn chắc chắn mở khóa người dùng này không?", {
          confirmButtonText: "Đồng ý",
          cancelButtonText: "Huỷ",
          type: "warning",
        })
          .then(() => {
            this.fn_disable(row.id, false);
          })
          .catch(() => {});
      }
    },

    //delete
    async fn_delete(id) {
      await mushroomDulich.notification_log.deleteAsync(id);
      this.fn_initTable();
    },

    //khóa tài khoản
    async fn_disable(id, disable) {
      await mushroomDulich.notification.partialUpdateAsync(id, disable);
      this.fn_initTable();
    },

    //event table

    fn_tableSelectionChange(val) {
      var _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function (element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    // search
    fn_tableSearch() {
      if (this.mData.tableRules.dataSearch.value.title) {
        this.mData.tableRules.dataSearch.value.title =
          this.mData.tableRules.dataSearch.value.title.trim();
      }
      if (!this.mData.tableRules.dataSearch.value.from) {
        this.hoTen = "";
      }
      if (!this.mData.tableRules.dataSearch.value["target.targetId"]) {
        this.tenTour = "";
      }

      // this.$refs["myForm"].validate(async valid => {
      //   if (valid) {
      let stringFilterAdd = "";
      if (this.mData.expiredTime && this.mData.expiredTime.length > 0) {
        stringFilterAdd =
          "expiredTime>=" +
          this.mData.expiredTime[0] +
          (this.mData.expiredTime[1] ||
          this.mData.tableRules.dataSearch.value.title ||
          this.mData.tableRules.dataSearch.value.createdTime
            ? "&"
            : "");
        if (this.mData.expiredTime[1]) {
          stringFilterAdd +=
            "expiredTime<=" +
            MethodService.addDate(this.mData.expiredTime[1], "days", 1) +
            (this.mData.tableRules.dataSearch.value.title ||
            this.mData.tableRules.dataSearch.value.createdTime
              ? "&"
              : "");
        }
      }
      console.log(stringFilterAdd);

      this.mData.tableRules.filters =
        `${stringFilterAdd != "" ? stringFilterAdd + "&" : stringFilterAdd}` +
        MethodService.filterTable(
          JSON.stringify(this.mData.tableRules.dataSearch)
        );
      this.mData.tableRules.offset = 0;
      this.mData.tableRules.sort = "";
      this.fn_initTable();
      //   } else {
      //     MethodService.stopLadda();
      //     return false;
      //   }
      // });
    },
    fn_tableSearchDefault() {
      let stringFilterAdd = "";
      if (this.mData.expiredTime && this.mData.expiredTime.length > 0) {
        stringFilterAdd =
          "expiredTime>=" +
          this.mData.expiredTime[0] +
          (this.mData.expiredTime[1] ||
          this.mData.tableRules.dataSearch.value.title ||
          this.mData.tableRules.dataSearch.value.createdTime
            ? "&"
            : "");
        if (this.mData.expiredTime[1]) {
          stringFilterAdd +=
            "expiredTime<=" +
            MethodService.addDate(this.mData.expiredTime[1], "days", 1) +
            (this.mData.tableRules.dataSearch.value.title ||
            this.mData.tableRules.dataSearch.value.createdTime
              ? "&"
              : "");
        }
      }

      this.mData.tableRules.filters =
        `${stringFilterAdd != "" ? stringFilterAdd + "&" : stringFilterAdd}` +
        MethodService.filterTable(
          JSON.stringify(this.mData.tableRules.dataSearch)
        );
      this.mData.tableRules.offset = 0;
      this.mData.tableRules.sort = "";
      this.fn_initDataDefault();
    },

    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch =
        !this.mData.tableRules.showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-list",
        query: query,
      });
    },

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue, index) {
      if (cellValue) {
        return MethodService.formatDate(cellValue, "datetime");
      } else {
        return "Chưa có thông tin";
      }
    },

    fn_formatterType(row, column, cellValue, index) {
      let itemResult = ThongBaoModel.typeNotifiType.find((item) => {
        return item.code == cellValue;
      });
      if (itemResult) {
        return itemResult.name;
      } else {
        return "";
      }
    },

    async fn_initDataDefault() {
      if (MethodService.checkRole("Admin,Officer")) {
        this.mData.dataDefault.typeNotifi =
          ThongBaoModel.typeNotifiAdminOfficer;
      }
      if (MethodService.checkRole("TourAgent")) {
        this.mData.dataDefault.typeNotifi = ThongBaoModel.typeNotifiTourAgent;
      }
      let dataFilter = {
        filters: "type=" + this.mData.tableRules.dataSearch.value.type,
      };

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }

      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: "Admin-" + this.mData.moduleName + "-list",
            query: {
              limit: this.mData.tableRules.limit,
              page: this.mData.tableRules.page,
              sort: this.mData.tableRules.sort,
              filters: this.mData.tableRules.filters,
              showFormSearch: this.mData.tableRules.showFormSearch,
            },
          })
          .catch(() => {});
      }

      let res = await mushroomDulich.notification_log.listAsync(dataFilter);
      let resData = this.changeData(res.result);
      let fromIds = [];
      let targetArr = [];
      let tourtIds = [];
      fromIds = MethodService.findListItemDifferent(resData, "from");
      targetArr = MethodService.findListItemDifferent(resData, "target");
      tourtIds = MethodService.findListItemDifferent(targetArr, "targetId");
      const reqKhachDuLichApi = await mushroomDulich.khach_du_lich.listAsync({
        limit: fromIds.length,
        filters: "id:in:" + fromIds.join(","),
      });
      const reqHuongDanVienApi = await mushroomDulich.huong_dan_vien.listAsync({
        limit: fromIds.length,
        filters: "id:in:" + fromIds.join(","),
      });
      const reqTourApi = await mushroomDulich.tour.listAsync({
        limit: tourtIds.length,
        filters: "id:in:" + tourtIds.join(","),
      });
      const reqPhieuDieuTourApi = await mushroomDulich.phieu_dieu_tour.listAsync({
        limit: tourtIds.length,
        filters: "id:in:" + tourtIds.join(","),
      });
      let tourIdsFromPhieuDieuTour = MethodService.findListItemDifferent(
        reqPhieuDieuTourApi.result,
        "tour_id"
      );
      const reqTourFromPhieuDieuTour = await mushroomDulich.tour.listAsync({
        limit: tourIdsFromPhieuDieuTour.length,
        filters: "id:in:" + tourIdsFromPhieuDieuTour.join(","),
      });
      let resKhachDuLichApi = await reqKhachDuLichApi;
      let resHuongDanVienApi = await reqHuongDanVienApi;
      let resTourApi = await reqTourApi;
      let resPhieuDieuTourApi = await reqPhieuDieuTourApi;
      let resTourFromPhieuDieuTour = await reqTourFromPhieuDieuTour;

      this.mData.dataDefault.listKDLSearch = resKhachDuLichApi.result;
      this.mData.dataDefault.listHDVSearch = resHuongDanVienApi.result;
      this.mData.dataDefault.listTourSearch = resTourApi.result;
      this.mData.dataDefault.listPhieuDieuTourSearch =
        resPhieuDieuTourApi.result;
      this.mData.dataDefault.listTourFromPhieuDieuTourSearch =
        resTourFromPhieuDieuTour.result;
      this.mData.dataDefault.listPhieuDieuTourSearch.forEach((items) => {
        let tourFromPhieuDieuTour =
          this.mData.dataDefault.listTourFromPhieuDieuTourSearch.find(
            (element) => {
              return element.id == items.tour_id;
            }
          );
        if (tourFromPhieuDieuTour) {
          items.ten_tour = tourFromPhieuDieuTour.ten_tour;
        }
      });
      this.mData.dataDefault.listNameSearch =
        this.mData.dataDefault.listKDLSearch.concat(
          this.mData.dataDefault.listHDVSearch
        );
      this.mData.dataDefault.listTourSearchs =
        this.mData.dataDefault.listTourSearch.concat(
          this.mData.dataDefault.listPhieuDieuTourSearch
        );
      this.fn_tableSearch();
      console.log(
        "this.mData.dataDefault.listNameSearch trước",
        this.mData.dataDefault.listNameSearch
      );
      console.log(
        "this.mData.dataDefault.listTourSearchs trước",
        this.mData.dataDefault.listTourSearchs
      );
    },

    async fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        let stringFilter = this.$route.query.filters;
        let regex =
          /(expiredTime[><]=(\d){4}-(\d){2}-(\d){2}T(\d){2}:(\d){2}:(\d){2})/g;
        let stringExpiredTime = stringFilter.match(regex);
        let expiredTimeCache = [];
        if (stringExpiredTime && stringExpiredTime.length > 0) {
          stringExpiredTime.forEach((item, index) => {
            if (index != 1) {
              stringFilter = stringFilter.replace(item + "&", "");
              expiredTimeCache.push(item.replace("expiredTime>=", ""));
            } else {
              stringFilter = stringFilter.replace(item + "&", "");
              expiredTimeCache.push(
                MethodService.addDate(
                  item.replace("expiredTime<=", ""),
                  "days",
                  -1
                )
              );
            }
          });
        }
        this.mData.expiredTime = expiredTimeCache;
        // string to object
        if (stringFilter) {
          this.mData.tableRules.dataSearch.value =
            MethodService.stringToObject(stringFilter);
        }
        console.log(
          "this.mData.tableRules.dataSearch.value",
          this.mData.tableRules.dataSearch.value
        );
      }
      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
      await this.fn_initDataDefault();
      if (this.mData.tableRules.dataSearch.value.from) {
        let resKhachDL = await mushroomDulich.khach_du_lich.findByIdAsync({id: this.mData.tableRules.dataSearch.value.from}
        );
        if (resKhachDL.result) {
          // this.mData.dataDefault.listNameSearch.push(resKhachDL.result);
          this.hoTen = resKhachDL.result.ho_ten.ho_ten;
        } else {
          let resHDV = await mushroomDulich.huong_dan_vien.findByIdAsync({id: this.mData.tableRules.dataSearch.value.from}
          );
          if (resHDV.result) {
            // this.mData.dataDefault.listNameSearch.push(resHDV.result);
            this.hoTen = resHDV.result.ho_ten.ho_ten;
          }
        }
      }
      if (this.mData.tableRules.dataSearch.value["target.targetId"]) {
        let resTour = await mushroomDulich.tour.findByIdAsync({id: this.mData.tableRules.dataSearch.value["target.targetId"]}
        );
        if (resTour.result) {
          // this.mData.dataDefault.listTourSearchs.push(resTour.result);
          this.tenTour = resTour.result.ten_tour;
        } else {
          let resPhieuDieuTourApi =
            await mushroomDulich.phieu_dieu_tour.findByIdAsync({id: this.mData.tableRules.dataSearch.value["target.targetId"]}
            );
          if (resPhieuDieuTourApi.result) {
            // this.mData.dataDefault.listTourSearchs.push(resPhieuDieuTourApi.result);
            let resTourFromPhieuDieuTour =
              await mushroomDulich.tour.findByIdAsync({id: resPhieuDieuTourApi.result.tour_id}
              );
            this.tenTour = resTourFromPhieuDieuTour.result.ten_tour;
          }
        }
      }
      console.log(
        "this.mData.dataDefault.listNameSearch sau",
        this.mData.dataDefault.listNameSearch
      );
      console.log(
        "this.mData.dataDefault.listTourSearchs sau",
        this.mData.dataDefault.listTourSearchs
      );
    },
    fn_changeTypeNoti() {
      this.mData.tableRules.dataSearch.value.title = null;
      this.mData.tableRules.dataSearch.value.from = null;
      this.mData.tableRules.dataSearch.value["target.targetId"] = null;
      this.mData.tableRules.dataSearch.value.createdTime = null;
      this.mData.tableRules.dataSearch.value.expiredTime = null;

      if (
        this.mData.tableRules.dataSearch.value.type == "" &&
        this.currentUser.roles.includes("TourAgent")
      ) {
        this.mData.tableRules.dataSearch.value.type = "MessageToTourist";
      } else if (this.mData.tableRules.dataSearch.value.type) {
        this.mData.tableRules.dataSearch.value.type =
          this.mData.tableRules.dataSearch.value.type;
      }
      this.fn_tableSearchDefault();
      if (this.mData.tableRules.dataSearch.value.type == "ConfirmTourMessage") {
        this.showCollumnTableContentTypeConfirmTourMessage = true;
        this.showCollumnTableContentTypeConfirmPDTMessage = false;
        this.showInputSearchTypeConfirm = true;
      } else if (
        this.mData.tableRules.dataSearch.value.type == "ConfirmPDTMessage"
      ) {
        this.showCollumnTableContentTypeConfirmTourMessage = false;
        this.showCollumnTableContentTypeConfirmPDTMessage = true;
        this.showInputSearchTypeConfirm = true;
      } else {
        this.showCollumnTableContentTypeConfirmTourMessage = false;
        this.showCollumnTableContentTypeConfirmPDTMessage = false;
        this.showInputSearchTypeConfirm = false;
      }
    },
    async querySearchHoTen(queryString, cb) {
      queryString = queryString.trim();

      var results = queryString
        ? this.mData.dataDefault.listNameSearch.filter((item) =>
            item.ho_ten && item.ho_ten.ho_ten
              ? item.ho_ten.ho_ten
                  .toLowerCase()
                  .includes(queryString.toLowerCase())
              : ""
          )
        : this.mData.dataDefault.listNameSearch;
      // call callback function to return suggestions
      cb(results);
    },
    handleSelectHoTen(item) {
      this.mData.tableRules.dataSearch.value.from = item.id;
      this.hoTen = item.ho_ten.ho_ten;
    },

    async querySearchTour(queryString, cb) {
      console.log(
        "this.mData.dataDefault.listNameSearch",
        this.mData.dataDefault.listNameSearch
      );
      queryString = queryString.trim();

      var results = queryString
        ? this.mData.dataDefault.listTourSearchs.filter((item) =>
            item.ten_tour.toLowerCase().includes(queryString.toLowerCase())
          )
        : this.mData.dataDefault.listTourSearchs;
      // call callback function to return suggestions
      cb(results);
    },
    handleSelectTour(item) {
      this.mData.tableRules.dataSearch.value["target.targetId"] = item.id;
      this.tenTour = item.ten_tour;
    },
  },

  //run after render view
  created() {
    this.fn_hashUrl();
    this.fn_changeTypeNoti();
  },
  mounted() {
    // this.mData.tableRules.dataSearch.value.type = "MessageToTourist";
    // this.fn_initDataDefault();
    this.fn_initTable();
  },
};
</script>

<style scoped>
p {
  margin-bottom: 0;
}
::v-deep .el-date-editor .el-range-separator {
  width: unset !important;
}
.el-autocomplete.inline-input {
  width: 100%;
}
.ws-normal {
  white-space: normal;
}
</style>
